import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Badge, Dropdown, Button } from "react-bootstrap";
import { searchWord } from "../../helpers/common";
import { SearchInput } from "../widgets";
import { useLoadHistoryContext } from "./context/LoadHistoryContext";
import {
  maxLoadCountForFilter,
  minLoadCountForFilter,
} from "./LoadHistoryFilter";

const FilterDropdown = ({
  data,
  dropdownList,
  onSelect,
  searchBar,
  filterName,
  nonEmptyLoadList,
  localFilterState,
  setLocalFilterState,
}) => {
  const { filter, setFilter } = useLoadHistoryContext();
  const [searchText, setSearchText] = useState("");
  const [isShow, setIsShow] = useState(false);
  const loadHistory = useSelector((state) => state.equipmentGroup.loadHistory);

  const filterCondition =
    nonEmptyLoadList.length > minLoadCountForFilter &&
    nonEmptyLoadList.length < maxLoadCountForFilter;

  const checkUnknown = (name) => (name || "").toLowerCase() === "unknown";

  useEffect(() => {
    setLocalFilterState(filter);
  }, [isShow]);

  const filteredDropDownList = useMemo(() => {
    const filteredDropDown = [];
    dropdownList.forEach((item) => {
      if (checkUnknown(item.label)) filteredDropDown.unshift(item);
      else filteredDropDown.push(item);
    });

    if (searchText.trim().length > 0)
      return filteredDropDown.filter((item) =>
        searchWord(item.label, searchText)
      );
    return filteredDropDown;
  }, [searchText, dropdownList]);

  return (
    <Dropdown
      className="filter-dropdown-container"
      show={isShow}
      onToggle={() => setIsShow(!isShow)}
    >
      <Dropdown.Toggle
        className="filter-dropdown-toggle"
        disabled={loadHistory.isRequesting || nonEmptyLoadList.length === 0}
      >
        <i className="fa fa-filter filter-btn" title="Filter" />
        {filter[filterName].length > 0 && (
          <Badge variant="warning" className="badge-filter-count">
            {filter[filterName].length}
          </Badge>
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu align="right" className="networkStatus">
        {searchBar && (
          <div className="mx-2 mb-1">
            <SearchInput onChange={(searchText) => setSearchText(searchText)} />
          </div>
        )}
        <div className={"filter-dropdown-menu-custom"}>
          {filteredDropDownList.map((item) => {
            return (
              <div key={item.id} className={`filter-dropdown-item-custom`}>
                <label>
                  <span>
                    <input
                      type="checkbox"
                      checked={data.map((item) => item.id).includes(item.id)}
                      onChange={
                        filterCondition
                          ? (e) => {
                              let selectedItems = [
                                ...localFilterState[filterName],
                              ];
                              if (e.target.checked) selectedItems.push(item);
                              else
                                selectedItems = selectedItems.filter(
                                  (e) => e.id !== item.id
                                );
                              setLocalFilterState({
                                ...localFilterState,
                                [filterName]: selectedItems,
                              });
                            }
                          : (e) => onSelect(filterName, item, e.target.checked)
                      }
                    />
                  </span>
                  <span
                    className={`item-text ${
                      checkUnknown(item.label) ? "text-danger" : ""
                    }`}
                  >
                    {item.label}
                  </span>
                </label>
              </div>
            );
          })}
        </div>
        <div className="filter-dropdown-button-custom w-100">
          {filteredDropDownList.length !== 0 && filterCondition && (
            <Button
              variant="success"
              size="sm"
              onClick={() => {
                setFilter({
                  ...filter,
                  [filterName]: localFilterState[filterName],
                });
                setIsShow(false);
              }}
              className="px-2 mx-2 w-50 filter-apply-button-custom"
            >
              Apply
            </Button>
          )}
          {filteredDropDownList.length !== 0 && filterCondition && (
            <Button
              variant="danger"
              size="sm"
              onClick={() => {
                setFilter({ ...filter, [filterName]: [] });
                setLocalFilterState({ ...localFilterState, [filterName]: [] });
                setIsShow(false);
              }}
              className="px-2 mx-2 w-50"
            >
              Clear
            </Button>
          )}
        </div>
        {filteredDropDownList.length === 0 && (
          <div className="text-sm-center my-3 font-weight-normal">
            No data found
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default FilterDropdown;